import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { text: String };

  copy(event) {
    const btn = event.currentTarget;
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = btn.innerHTML;
      btn.innerHTML = "Copied!";
      setTimeout(() => (btn.innerHTML = original), 2000);
    });
  }
}
